import frontMale from "modules/assets/body-model/male1.png";
import leftMale from "modules/assets/body-model/male2.png";
import backMale from "modules/assets/body-model/male3.png";
import rightMale from "modules/assets/body-model/male4.png";
import frontFemale from "modules/assets/body-model/female1.png";
import leftFemale from "modules/assets/body-model/female2.png";
import backFemale from "modules/assets/body-model/female3.png";
import rightFemale from "modules/assets/body-model/female4.png";

export default {
  male: {
    front: frontMale,
    left: leftMale,
    back: backMale,
    right: rightMale
  },
  female: {
    front: frontFemale,
    left: leftFemale,
    back: backFemale,
    right: rightFemale
  }
};



// WEBPACK FOOTER //
// ./src/modules/pain-profile/body-image.js